"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomRef = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_dom_1 = (0, tslib_1.__importDefault)(require("react-dom"));
var merge_refs_1 = require("../_util/merge-refs");
var attach_props_1 = require("../_util/attach-props");
var DomRefInner = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(DomRefInner, _super);
    function DomRefInner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DomRefInner.prototype.componentDidMount = function () {
        var dom = react_dom_1.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
        var domRef = this.props.domRef;
        (0, merge_refs_1.mergeRefs)(domRef)(dom);
    };
    DomRefInner.prototype.componentDidUpdate = function () {
        var dom = react_dom_1.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
        var domRef = this.props.domRef;
        (0, merge_refs_1.mergeRefs)(domRef)(dom);
    };
    DomRefInner.prototype.componentWillUnmount = function () {
        var domRef = this.props.domRef;
        (0, merge_refs_1.mergeRefs)(domRef)(null);
    };
    DomRefInner.prototype.render = function () {
        var _a = this.props, children = _a.children, domRef = _a.domRef, props = (0, tslib_1.__rest)(_a, ["children", "domRef"]);
        var childrenElement = children;
        // 元素类型的，可以把要求渲染的 childrenProps 和原本的 props 合并
        if (react_1.default.isValidElement(childrenElement)) {
            return react_1.default.cloneElement(childrenElement, (0, attach_props_1.attachProps)(childrenElement.props, props));
        }
        return children;
    };
    return DomRefInner;
}(react_1.default.Component));
exports.DomRef = (0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement(DomRefInner, (0, tslib_1.__assign)({}, props, { domRef: ref }))); });
